import { render, staticRenderFns } from "./ConsentBanner.vue?vue&type=template&id=3a96d4a3&"
import script from "./ConsentBanner.vue?vue&type=script&lang=js&"
export * from "./ConsentBanner.vue?vue&type=script&lang=js&"
import style0 from "./ConsentBanner.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports